import api from 'base/utils/api';
import { ICountry, ILocale } from 'mod/store/locale/interface';
import { filterFields } from 'ava-util/dist/data';

/**
 * 根据ip获取国家和货币信息
 * @param ip request 请求中的ip
 * TODO API: 精简返回值；返回值改成全大写
 */
export function getIPLocale(ip: string): Promise<ILocale> {
    return api.get('/web/locale/info', { params: { ip } }).then(res => {
        return {
            country: res.countryCode.toUpperCase(),
            currency: res.currencyCode.toUpperCase(),
            lang: res.languageCode
        }
    });
}

/**
 * 获取语言货币国家列表
 * TODO API: 精简返回值(接口中注释掉的属性)
 */
export function getLocaleList(): Promise<ICountry[]> {
    return api.get('/web/locale/list/v2').then(res => {
        return filterFields(res.countryList, {
            keepFields: ['countryCode', 'countryName', 'countryId', 'currencyList', 'languageList'],
            currencyList: ['defaultValue', 'code', 'currencySymbol'],
            languageList: ['defaultValue', 'code', 'name'],
        });
    });
}
